import React from "react";
import "./ClientSlider.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function ClientSlider({ clients }) {
  const clientsettings = {
    arrows: false,
    dots: false, // Hide dots
    infinite: true, // Enable infinite loop
    speed: 1000, // Transition speed
    centerMode: true, // key to show partial next slide
    centerPadding: "40px", // adjust for spacing/peek
    slidesToShow: 3.5, // show two full and one half slide
    autoplay: true, // Enable autoplay
    autoplaySpeed: 3000, // Autoplay interval
    draggable: true, // Enable dragging
    swipeToSlide: true, // Allow swiping
    pauseOnHover: false, // Continue autoplay on hover
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1214,
        settings: {
          slidesToShow: 2.5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.5,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.5,
        },
      },
    ],
  };
  return (
    <div className="homelistclient-container">
      <Slider {...clientsettings}>
        {clients.map((content, index) => (
          <div key={content.id} className="listclient-card">
            <img
              src={process.env.REACT_APP_BACKEND_URL_IMAGES + content.imageUrl}
              alt={content.alt}
              width={300}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default ClientSlider;
